import { gql } from "@apollo/client";

export const ADD_EVENT = gql`
  mutation AddProceedingEvent($input: ProceedingEvent) {
    addProceedingEvent(input: $input) {
      result
    }
  }
`;

export const GET_ALL_EVENTS = gql`
  query ProceedingEvents($input: String) {
    proceedingEvents(input: $input) {
      data {
        id
        type
        applicantName
        description
        typeNumber
        source
      }
    }
  }
`;

export const DELETE_PROCEEDING_EVENT = gql`
  mutation DeleteProceedingEvent($input: ProceedingEventToDelete) {
    deleteProceedingEvent(input: $input) {
      result
    }
  }
`;

export const GET_IAR_APPLICATION_DETAIL = gql`
  query GetApplicationDetails($input: String) {
    iarApplication(input: $input) {
      data {
        exists
        proceedingNumberIarApplication
      }
    }
  }
`;

export const CHECK_ONE_STOP_APPLICATION_EXISTENCE = gql`
  query CheckOneStopApplication($input: String) {
    oneStopApplication(input: $input) {
      data {
        exists
      }
    }
  }
`;


export const SEARCH_MEMBERS = gql`
  query SearchMembers($input: String!) {
    searchMembers(input: $input) {
      id
      displayName
      firstName
      lastName
      phoneNumber
      email
    }
  }
`;

export const GET_PROCEEDING_EVENT_DETAILS = gql`
  query GetProceedingEventDetails($input: EventQuery) {
    eventDetails(input: $input) {
      id
      type
      applicantName
      applicantBaId
      description
      typeNumber
      source
    }
  }
`;

export const UPDATE_PROCEEDING_EVENT = gql`
  mutation UpdateProceedingEvent($input: ProceedingEvent) {
    updateProceedingEvent(input: $input) {
      result
    }
  }
`;

export const typeOptions = [
  { value: 'Application', label: 'Application' },
  { value: 'Regulatory Appeal', label: 'Regulatory Appeal' },
  { value: 'Reconsideration', label: 'Reconsideration' },
  { value: 'Inquiry', label: 'Inquiry' },
];

export const sourceOptions = [
  { value: 'IAR', label: 'IAR' },
  { value: 'OneStop 1.0', label: 'OneStop 1.0' },
];